module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingVideo),
      expression: "loadingVideo"
    }],
    staticClass: "loader-wrap"
  }, [_c('div', {
    staticClass: "loader"
  })]), _vm._v(" "), (_vm.account.account.login) ? _c('div', {
    attrs: {
      "id": "main"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.hideTab($event)
      }
    }
  }, [_c('ChannelList', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab.current == 'channels'),
      expression: "tab.current == 'channels'"
    }],
    ref: "channelList",
    attrs: {
      "teletekaEnabled": _vm.teletekaEnabled
    },
    on: {
      "openChannel": _vm.openChannel,
      "apiGetChannelList": _vm.apiGetChannelList
    }
  }), _vm._v(" "), _c('MessagesList', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab.current == 'messages'),
      expression: "tab.current == 'messages'"
    }]
  }), _vm._v(" "), _c('Settings', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab.current == 'settings'),
      expression: "tab.current == 'settings'"
    }],
    ref: "settings",
    on: {
      "getLogout": _vm.getLogout
    }
  }), _vm._v(" "), _c('div', {
    class: {
      'debug-mode': (_vm.debugSettings.statsEnabled || _vm.debugSettings.metricsEnabled)
    },
    attrs: {
      "id": "player"
    }
  }, [_c('Slideshow', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.channel && !_vm.channel.is_video),
      expression: "channel && !channel.is_video"
    }],
    ref: "slideshow"
  }), _vm._v(" "), _c('VideoPlayer', {
    ref: "myPlayer"
  }), _vm._v(" "), _c('VideoControl', {
    ref: "videoControl",
    class: {
      loading: _vm.loadingChannel
    },
    attrs: {
      "loadingVideo": _vm.loadingVideo,
      "hls": _vm.hls
    },
    on: {
      "getLogout": _vm.getLogout,
      "updateProgramInfo": _vm.updateProgramInfo,
      "saveCurrentProgramToArchiveInfo": _vm.saveCurrentProgramToArchiveInfo
    }
  })], 1), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab.current && _vm.channel),
      expression: "tab.current && channel"
    }],
    staticClass: "close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.hideTab($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])], 1) : _vm._e(), _vm._v(" "), _c('Login', {
    ref: "loginComponent"
  }), _vm._v(" "), _c('vueToast', {
    ref: "toast"
  }), _vm._v(" "), _c('modal', {
    staticClass: "modal",
    attrs: {
      "name": "teleteka",
      "width": "200",
      "height": "200"
    },
    on: {
      "before-close": _vm.beforeModalClose
    }
  }, [_c('div', {
    staticClass: "modal_content"
  }, [_c('h4', [_vm._v("\n                Передача окончена. Продолжить просмотр в архиве?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "modal_buttons"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showNextArchivedProgram($event)
      }
    }
  }, [_vm._v("Да (" + _vm._s(_vm.teletekaTimer) + ")")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.dismissModal($event)
      }
    }
  }, [_vm._v("Нет")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-01c3ce44!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 85
// module chunks = 0